import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Login = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        devLog('Login:', formData);
    };

    const inputClass = "w-full pl-10 pr-4 py-3 text-sm bg-[#1A1A1A] border border-[#2A2A2A] text-white placeholder-[#525252] focus:outline-none focus:border-[#FF6B35] transition-colors font-['Montserrat']";

    return (
        <div className="w-full min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />

            <div className="w-full max-w-md">
                {/* Brand */}
                <div className="text-center mb-10">
                    <h1
                        onClick={() => navigate('/template2')}
                        className="text-3xl font-extrabold text-white tracking-[4px] cursor-pointer mb-2 font-['Montserrat']"
                    >
                        RANG
                    </h1>
                    <p className="text-sm text-[#A3A3A3] font-['Montserrat']">Welcome back</p>
                </div>

                <div className="bg-[#1A1A1A] border border-[#2A2A2A] p-6 md:p-8">
                    <h2 className="text-xl font-bold text-white mb-6 font-['Montserrat'] uppercase tracking-wider">Sign In</h2>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-semibold text-[#A3A3A3] uppercase tracking-wider mb-2 font-['Montserrat']">Email</label>
                            <div className="relative">
                                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#525252]" />
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="you@email.com"
                                    className={inputClass}
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-semibold text-[#A3A3A3] uppercase tracking-wider mb-2 font-['Montserrat']">Password</label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#525252]" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    placeholder="Enter password"
                                    className={`${inputClass} pr-10`}
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-[#525252] hover:text-[#FF6B35]"
                                >
                                    {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                                </button>
                            </div>
                        </div>

                        <div className="flex justify-end">
                            <button type="button" className="text-xs text-[#FF6B35] hover:underline font-['Montserrat']">
                                Forgot Password?
                            </button>
                        </div>

                        <Button variant="primary" size="lg" fullWidth type="submit">
                            Sign In
                        </Button>
                    </form>

                    <p className="text-center mt-6 text-sm text-[#A3A3A3] font-['Montserrat']">
                        Don't have an account?{' '}
                        <span
                            onClick={() => navigate('/template2/signup')}
                            className="text-[#FF6B35] font-semibold cursor-pointer hover:underline"
                        >
                            Create Account
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
